import React from "react";
import { Card } from "antd";
import Helmet from "react-helmet";
import Applications from "./applications";
import AllowanceRates from "./allowance-rates";
import Activities from "./activities";
import ArtUnitLawFirms from "./art-unit-law-firms";
import DefaultFilterAlert from "./alert-default-filter";
import { PUBLIC_URL } from "../../config";
import { QuestionCircleOutlined } from "@ant-design/icons";
import { toTitleCase } from "../../helpers/converters";

const styles = {
  body: {
    width: "100%",
    padding: 30
  },
  card: {
    marginTop: 16
  },
  title: {
    fontSize: 28,
    display: "flex",
    alignItems: "center",
    flexWrap: "wrap",
    gap: 16
  },
  linkInTitle: {
    fontSize: 12,
    marginLeft: 8
  }
};

const EntityDetail = props => {
  const { type, field } =
    props.location.pathname.indexOf("examiner") >= 0
      ? { type: "Examiner", field: "examiner_name" }
      : props.location.pathname.indexOf("lawfirm") >= 0
        ? { type: "Law Firm", field: "law_firm" }
        : { type: "Art Unit", field: "examiner_art_unit" };
  const name = props.params.name;
  const descriptionExtra = `for ${type} ${name}`;
  const helmet = {
    title: `Patent Prosecution Analytics ${descriptionExtra}`,
    meta: [
      {
        name: "keywords",
        content: `USPTO,patent prosecution,${type},${name},allowance rate,applications,PAIR,PatEx,portal`
      },
      {
        name: "description",
        content: `Patent Prosecution Analytics ${descriptionExtra}. Get allowance rates and effects of Final Rejection, Interview, Appeal and RCE. See all activities and processed applications.`
      }
    ],
    link: [
      {
        rel: "canonical",
        href: encodeURI(PUBLIC_URL + decodeURI(props.router.location.pathname.toLowerCase()))
      }
    ]
  };
  const lpixTitle = (
    <span>
      {"Law Firm Prosecution Index (LPIX) "}
      <a href={"https://support.unifiedpatents.com/hc/en-us/articles/1500008569821-Law-Firm-Prosecution-Index-LPIX-The-World-s-First-Objective-Tool-for-Patent-Prosecution-Success"} target="_new">
        <QuestionCircleOutlined />
      </a>
    </span>
  );
  return (
    <div style={styles.body} key={name}>
      <Helmet {...helmet} />
      {name && (
        <div>
          <div style={styles.title}>
            <b>Prosecution Analytics</b>
            <span>{type} {toTitleCase(name)}</span>
          </div>
          <DefaultFilterAlert style={{ marginTop: 16 }} />
          <Card title="Allowance Rates" style={styles.card}>
            <AllowanceRates name={name} field={field} />
          </Card>
          {type === "Art Unit" && (
            <Card title={lpixTitle} style={styles.card}>
              <ArtUnitLawFirms artUnit={name} />
            </Card>
          )}
          <Card title="Decisions" style={styles.card}>
            <Activities name={name} field={field} />
          </Card>
          <Card title="Recent Applications" style={styles.card}>
            <Applications name={name} field={field} />
          </Card>
        </div>
      )}
    </div>
  );
};

export default EntityDetail;
